export default {"src":"/_next/static/media/LegacyFinal.0ea858fe.svg","height":66,"width":68,"blurWidth":0,"blurHeight":0};